<script>
import { getOnShelfCases, getFeaturedCases } from '../../api/case';
import { leftLikeDict } from '../../api/system';
import Constant from '../../utils/Constant';

export default {
  name: 'CaseList',
  data() {
    return {
      caseBanner: {},
      caseList: [],
      page: 0,
      pageSize: 12,
      loading: false,
      noMore: false
    }
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.CASE_BANNER);
      if (res.data && res.data.data) {
        const bannerData = res.data.data;
        this.caseBanner = {
          title: '',
          subtitle: '',
          image: ''
        };
        
        bannerData.forEach(item => {
          if (item.dictKey === Constant.CASE_BANNER_TITLE) {
            this.caseBanner.title = item.dictValue;
          } else if (item.dictKey === Constant.CASE_BANNER_SUB_TITLE) {
            this.caseBanner.subtitle = item.dictValue;
          } else if (item.dictKey === Constant.CASE_BANNER_IMAGE) {
            this.caseBanner.image = item.dictValue;
          }
        });
      }
    },


    async getCasesFunc() {
      if (this.loading || this.noMore) return;

      this.loading = true;

      try {
        const params = {
          page: this.page,
          size: this.pageSize
        };

        const res = await getOnShelfCases(params);

        if (res.data && res.data.data && res.data.data.content) {
          const newData = res.data.data.content;

          if (newData.length < this.pageSize) {
            this.noMore = true;
          }

          if (this.page === 0) {
            this.caseList = newData;
          } else {
            this.caseList = [...this.caseList, ...newData];
          }

          if (newData.length > 0) {
            this.page++;
          }
        } else {
          this.noMore = true;
        }
      } catch (error) {
        console.error('加载失败', error);
      } finally {
        this.loading = false;
      }
    },

    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.getCasesFunc();
      }
    },

    openCaseDetail(id) {
      if (this.$router && this.$router.resolve) {
        const routeData = this.$router.resolve({ path: '/case_detail/' + id });
        window.open(routeData.href, '_blank');
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
    this.getCasesFunc()
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<template>
  <div class="case_wrap">
    <!-- 顶部Banner -->
    <div class="case_banner" :style="{ background: `url(${caseBanner.image}) center center no-repeat`, backgroundSize: 'cover' }">
      <div class="banner_content" v-if="caseBanner.title || caseBanner.subtitle">
        <div class="banner_title" v-if="caseBanner.title">{{ caseBanner.title }}</div>
        <div class="banner_desc" v-if="caseBanner.subtitle">{{ caseBanner.subtitle }}</div>
      </div>
    </div>

    <div class="container">
      <h2 class="section-title">客户案例</h2>

      <!-- 案例网格 -->
      <div class="case-grid">
        <article class="case-card" v-for="item in caseList" :key="item.id" @click="openCaseDetail(item.id)">
          <div class="card-image-wrapper">
            <img :src="item.image" :alt="'案例 ' + item.id" class="card-image" />
          </div>
        </article>
      </div>

      <!-- 加载状态 -->
      <div class="footer-status">
        <div v-if="loading" class="loading-box">
          <span class="loading-icon"></span> 努力加载中...
        </div>
        <div v-if="noMore && caseList.length > 0" class="no-more-line">
          <span>已显示全部案例</span>
        </div>
        <div v-if="noMore && caseList.length === 0" class="empty-box">
          暂无案例
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.case_wrap {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
}

.case_banner {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #1a1a1a;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
  }
}

.banner_content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: #fff;
}

.banner_title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner_desc {
  font-size: 20px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}


.section-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  color: #333;
  position: relative;
  
  &::after {
    content: '';
    display: block;
    width: 60px;
    height: 4px;
    background: #409eff;
    margin: 15px auto 0;
    border-radius: 2px;
  }
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 40px;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 15px;
  }
}

.case-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

}

.card-image-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
}

.card-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  transition: transform 0.3s;

  .case-card:hover & {
    transform: scale(1.05);
  }
}

.footer-status {
  text-align: center;
  padding: 40px 0;
}

.loading-box {
  font-size: 16px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loading-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #409eff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.no-more-line {
  font-size: 14px;
  color: #999;
  position: relative;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 100px;
    height: 1px;
    background: #e0e0e0;
  }
  
  &::before {
    right: calc(50% + 80px);
  }
  
  &::after {
    left: calc(50% + 80px);
  }
  
  span {
    padding: 0 20px;
  }
}

.empty-box {
  font-size: 16px;
  color: #999;
  padding: 60px 0;
}

@media screen and (max-width: 768px) {
  .case_banner {
    height: 250px;
  }

  .banner_title {
    font-size: 32px;
  }

  .banner_desc {
    font-size: 16px;
  }

  .container {
    padding: 30px 15px;
  }

  .section-title {
    font-size: 24px;
    margin-bottom: 30px;
  }

  .featured-section {
    margin-bottom: 40px;
  }
}
</style>
